export const getStringReadTime = text => {
  const readSpeed = 250
  const wordArr = text.split(' ')
  const wordCount = wordArr.length
  return Math.ceil(wordCount / readSpeed)
}
